import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Address from '../../GenericComponents/Address';
function PublicAddress({ isReadOnly, boundValues, isUserEditable, copyFromMailing, contactInfoLink }) {
    return (
        <Card>
            <Card.Header>




                <Row>
                    <Col className='d-flex align-items-center'>
                        <h6>Verify Public Address</h6>
                    </Col>
                    {(isReadOnly && isUserEditable) &&
                        <Col className='d-flex justify-content-end'>
                            <Button as={Link} to={contactInfoLink} variant="dark" target="_blank">
                                Update Contact Information</Button>
                        </Col>
                    }
                    {(copyFromMailing) &&
                        <Col className='d-flex justify-content-end'>
                            <Button onClick={copyFromMailing} variant="dark" >
                                Copy From Mailing</Button>
                        </Col>
                    }

                </Row>
            </Card.Header>
            <Card.Body>
                <p style={{ color: '#EB0000' }} className="mb-3"><strong>* THIS ADDRESS WILL BE POSTED ON THE WEBSITE</strong></p>
                <Address
                    boundValues={boundValues}
                    readOnly={isReadOnly}
                />

            </Card.Body>
        </Card>

    );
}
export default PublicAddress;